// extracted by mini-css-extract-plugin
module.exports = {"useFade-fadeIn":"ProductCartCardActions_useFade-fadeIn__64vCR","useFade-fadeOut":"ProductCartCardActions_useFade-fadeOut__89Ywl"};